<template>
  <div class="NascidoSV">
    <div class="row">
      <div class="col-3">
        <div class="form-group">
          <label for="cpf"
                 class="label">CPF</label>
          <div class="input-group">
            <input id="cpf"
                   v-model="registro.pessoa.cpf"
                   v-mask="'999.999.999-99'"
                   type="text"
                   class="form-control form-control-sm"
                   name="cpf"
                   placeholder="000.000.000-00"
                   :disabled="registro.pessoa.cpf_origem == 'CRC'"
                   @change="changed">
            <div class="input-group-append">
              <button class="btn btn-sm btn-primary"
                      @click="showModal = true">
                Averbar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="form group">
          <label for="Nome"
                 class="label">Nome</label>
          <input id="Nome"
                 v-model="registro.pessoa.nome"
                 v-validate="'required'"
                 type="text"
                 :class="{'is-invalid' : errors.has('nome')}"
                 class="form-control form-control-sm text-uppercase"
                 name="nome"
                 placeholder="Enzo Silva"
                 @change="changed(), nomeUpperCase()">
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-3">
        <div class="form group">
          <label for="data_nascimento"
                 class="label">Data nascimento</label>
          <input id="Nome"
                 v-model="registro.pessoa.data_nascimento"
                 v-validate="`required|date_format:yyyy-MM-dd|date_between:${ dataInicial() },${ dataLimite() }, (include)`"
                 type="date"
                 :class="{'is-invalid' : errors.has('data_nascimento')}"
                 class="form-control form-control-sm"
                 name="Data Nascimento"
                 @blur="changed">
        </div>
      </div>
      <div class="col-2">
        <div class="form group">
          <label for="hora"
                 class="label">Hora Nascimento</label>
          <input id="Nome"
                 v-model="registro.hora_ocorrido"
                 v-validate="'required'"
                 type="time"
                 :class="{'is-invalid' : errors.has('hora')}"
                 class="form-control form-control-sm"
                 name="hora"
                 placeholder="Hora"
                 @change="changed">
        </div>
      </div>
      <div class="col-3">
        <div class="form group">
          <label for="sexo-nascido"
                 class="label">Sexo</label>
          <select id="sexo-nascido"
                  v-model="registro.pessoa.sexo"
                  class="custom-select custom-select-sm"
                  name="sexo-nascido"
                  @change="changed">
            <option selected
                    value="">
              Selecione
            </option>
            <option v-for="sexo in SEXOS"
                    :key="sexo.value"
                    :value="sexo.value">
              {{ sexo.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-3 mt-2">
        <div class="form-group">
          <label class="label"
                 for="decNascidoVivo">Nº Declaração Nascido Vivo</label>
          <input id="decNascidoVivo"
                 v-model="dnv"
                 data-vv-validate-on="custom|blur"
                 :class="{ 'is-invalid': errors.has('decNascidoVivo') }"
                 class="form-control form-control-sm"
                 name="decNascidoVivo"
                 maxlength="11"
                 type="text"
                 @change="checkDnv">
          <small v-if="errors.has('decNascidoVivo')"
                 class="invalid-feedback">{{ errors.first('decNascidoVivo') }}</small>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 m-0 p-2">
        <div class="SegundaViaNascimento_header mb-2">
          Genitores
        </div>
      </div>
      <div v-for="(genitor, ind) in registro.pessoa.genitores"
           :key="ind"
           class="col-12">
        <GenitorSVNascimento :prop-genitor="genitor"
                             :prop-index-genitor="ind"
                             @removeGenitor="removeGenitor(ind)"
                             @deleteAvo="deleteAvo" />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 m-0 p-2">
        <div class="SegundaViaNascimento_header mb-2">
          Local ocorrência
        </div>
      </div>
      <div v-if="editLocalOcorrencia"
           class="col-12">
        <FormLocalOcorrencia :hide-search="false"
                             :edit="editLocalOcorrencia"
                             :dados="editLocalOcorrencia"
                             :prop-lista-hospitais="listaHospitais"
                             :prop-segunda-via="true"
                             @addOcorrencia="receiveOcorrencia" />
      </div>
      <div v-else
           class="col-12 mt-2">
        <button class="btn btn-sm btn-outline-primary btn-block btn-add-local"
                @click="addLocalOcorrencia()">
          <icon-svg icon="add"
                    class="icon-add mr-1" />
          Adicionar local de ocorrência
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 m-0 p-2">
        <div class="SegundaViaNascimento_header mb-2">
          Naturalidade
        </div>
      </div>
      <form autocomplete="off">
        <div class="col-12 p-0">
          <div class="col pb-2">
            <b-form-radio v-model="registro.pessoa.naturalidade_origem"
                          name="some-radios"
                          value="endereco_ocorrencia"
                          @change="changeTipoNaturalidade">
              A mesma do local da ocorrência
              <div class="row">
                <small v-if="naturalidadeControl.alerts.endereco_ocorrencia"
                       class="text-danger text-bold">- {{ naturalidadeControl.alerts.message }}</small>
              </div>
            </b-form-radio>
          </div>
          <div class="col pb-2">
            <b-form-radio v-model="registro.pessoa.naturalidade_origem"
                          name="some-radios"
                          value="endereco_mae"
                          @change="changeTipoNaturalidade">
              A mesma da residência cadastrada da mãe biológica
              <div class="row">
                <small v-if="naturalidadeControl.alerts.endereco_mae"
                       class="text-danger text-bold">- {{ naturalidadeControl.alerts.message }}</small>
              </div>
            </b-form-radio>
          </div>
          <div v-if="nome_pai"
               class="col pb-2">
            <b-form-radio v-model="registro.pessoa.naturalidade_origem"
                          name="some-radios"
                          value="endereco_pai"
                          @change="changeTipoNaturalidade">
              A mesma de <span class="text-capitalize">{{ nome_pai | firstCapitalize }}</span>
              <div class="row">
                <small v-if="naturalidadeControl.alerts.endereco_pai"
                       class="text-danger text-bold">- {{ naturalidadeControl.alerts.message }}</small>
              </div>
            </b-form-radio>
          </div>
        </div>
      </form>
    </div>
    <div class="row">
      <div class="col-12 m-0 p-2">
        <div class="SegundaViaNascimento_header mb-2">
          Gêmeos
        </div>
      </div>
      <div class="col-12 m-0 p-0">
        <div class="SegundaViaNascimento_body_content">
          <GemeosSV :prop-pessoa="registro.pessoa"
                    :prop-ordem-nascimento="propOrdemNascimento"
                    @removeGemeo="removeGemeo"
                    @updateOrdemNascimento="updateOrdemNascimento"
                    @updateFlag="updateFlag" />
        </div>
      </div>
    </div>
    <b-modal v-if="showModal"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             :hide-header="true"
             :hide-footer="true">
      <AverbacaoSV :prop-cpf="registro.pessoa.cpf"
                   :registro-id="registro.registro_id"
                   :prop-transporte="registro.transporte"
                   @hideModal="showModal = false" />
    </b-modal>
  </div>
</template>

<script>
  /* constants */
  import SEXOS from '@/constants/sexos'

  // components
  import GenitorSVNascimento from "@/components/SofiaRei/Nascimento/SegundaVia/GenitorSVNascimento"
  import GemeosSV from '@/components/SofiaRei/Nascimento/SegundaVia/GemeosSV.vue'
  import FormLocalOcorrencia from '@/components/SofiaRei/Nascimento/SegundaVia/LocalOcorrenciaNascimentoSV.vue'
  import AverbacaoSV from '@/components/SofiaRei/Nascimento/SegundaVia/AverbacaoSV'

  /* services */
  import HospitaisService from "@/services/HospitaisService"
  import ValidateDeclarationService from "@/services/Registros/ValidateDeclarationService"

  /* outros */
  import moment from "moment"

  export default {
    name: 'NascidoSV',
    components: {
      GenitorSVNascimento,
      GemeosSV,
      FormLocalOcorrencia,
      AverbacaoSV
    },
    props: {
      propRegistro: { type: Object, default: () => ({})},
      propOrdemNascimento: { type: Number, default: null },
      propDnv: { type: String, default: null }
    },
    data () {
      return {
        registro: {
          pessoa: {}
        },
        nome_pai: null,
        naturalidadeControl: {
          alerts: {
            endereco_ocorrencia: false,
            endereco_mae: false,
            endereco_pai: false,
            mensagem: null
          }
        },
        SEXOS,
        listaHospitais: [],
        dnv: null,
        editLocalOcorrencia: null,
        showModal: false,
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY'),
      }
    },
    watch: {
      propRegistro () {
        this.registro = this.propRegistro

        if (this.registro.local) {
          this.editLocalOcorrencia = {
            ...this.registro.local,
            endereco: {...this.registro.local.endereco},
            update: true
          }

        }
        this.getNomePai()
        this.getHospitais()
      },
      propDnv () {
        this.dnv = this.propDnv
      }
    },
    mounted () {
      this.registro = this.propRegistro
    },
    methods: {
      changed () {
        this.checkDnv()
        this.$emit('changed', this.registro)
      },
      removeGenitor (index) {
        const { genitores } = this.registro.pessoa

        if (genitores[index] && genitores[index].genitor_id) {
          this.$emit('removeGenitor',genitores[index].genitor_id)
        }

        this.registro.pessoa.genitores.splice(index, 1)
      },
      removeGemeo (index) {
        const { gemeos } = this.registro.pessoa

        if (gemeos[index] && gemeos[index].gemeo_id) {
          this.$emit('removeGemeo',gemeos[index].gemeo_id)
        }

        this.registro.pessoa.gemeos.splice(index, 1)
      },
      naturalidadeChanged () {
        this.changed()
      },
      changeTipoNaturalidade (tipo = null) {
        if (!tipo) {
          tipo = this.registro.pessoa.naturalidade_origem
        }
        else {
          this.registro.pessoa.naturalidade_origem = tipo
        }

        const { alerts } = this.naturalidadeControl
        alerts.endereco_mae = false
        alerts.endereco_ocorrencia = false
        alerts.endereco_pai = false

        const showError = (message) => {
          alerts.message = message
          alerts[tipo] = true
          this.$emit('receiveError', true)
        }

        const getEnderecoMom = () => {
          // usando filter ao invés de find para caso seja duas mães
          try {
            const { pessoa: { endereco } } = this.registro.pessoa.genitores.filter(genitor => genitor.pessoa.sexo == "F")[0]

            if (!endereco) {
              showError("Mãe com o endereço ainda não informado")
              return
            }

            tratandoEndereco(endereco)
          } catch (e) {
            showError("Mãe com o endereço ainda não informado")
            return
          }
        }

        const getEnderecoPai = () => {
          // usando filter ao invés de find para caso seja duas mães
          try {
            const { pessoa: { endereco } } = this.registro.pessoa.genitores.filter(genitor => genitor.pessoa.sexo == "M")[0]

            if (!endereco) {
              showError("Pai com o endereço ainda não informado")
              return
            }

            tratandoEndereco(endereco)
          } catch (e) {
            showError("Pai com o endereço ainda não informado")
            return
          }
        }

        const getEnderecoOcorrencia = () => {
          try {
            const { endereco } = this.registro.locaç

            if (!endereco) {
              showError("Local da ocorrência ainda não informado")
              return
            }

            tratandoEndereco(endereco)
          } catch (e) {
            showError("Local da ocorrência ainda não informado")
            return
          }
        }

        const tratandoEndereco = (endereco) => {
          const { cidade, uf, exterior } = endereco
          if (cidade && uf) {
            const naturalidade = `${ cidade } - ${ uf }`
            this.registro.pessoa.naturalidade_declarada = naturalidade
            this.registro.pessoa.naturalidade_origem = tipo
            this.naturalidadeChanged()
            return
          }

          let message = null

          if (exterior) {
            message = "O local de ocorrência não pode ser fora do Brasil"
          } else if (!cidade && uf) {
            message = "Cidade não informada"
          } else if (cidade && !uf) {
            message = "UF não informado"
          } else if (!(cidade && uf)) {
            message = "Local ainda não informado"
          }

          showError(message)
        }

        switch (tipo) {
        case 'endereco_ocorrencia':
          getEnderecoOcorrencia()
          break

        case 'endereco_mae':
          getEnderecoMom()
          break

        case 'endereco_pai':
          getEnderecoPai()
          break
        }
      },
      getNomePai () {
        const pai = this.registro.pessoa.genitores.filter(genitor => genitor.pessoa.sexo === 'M')

        if (pai && pai.length) {
          this.nome_pai = pai[0].pessoa.nome
        } else {
          this.nome_pai = null
        }
      },
      deleteAvo (avo_id) {
        this.$emit('deleteAvo', avo_id)
      },
      updateOrdemNascimento (ordem) {
        this.$emit('updateOrdemNascimento', ordem)
      },
      async getHospitais () {
        if (!this.registro.local) return

        const local = this.registro.local

        if (local.tipo == 'UNIDADE_SAUDE') {
          const payload = {
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: local.descricao,
            ativo: 1,
          }

          try {
            const result = await HospitaisService.getHospitais(payload)

            this.listaHospitais = result.data

          } catch (error) {
            console.error(error)
          }
        }
      },
      receiveOcorrencia (val) {
        const local = {...val}

        if ((val.hospital && val.hospital.hospital_id) || val.hospital_id || val.tipo === 'hospital') {
          local.tipo = "UNIDADE_SAUDE"
          local.descricao = val.descricao || val.nome
          local.sub_tipo = 'hospital'
        }

        switch (val.tipo) {
        case 'domicilio':
          local.descricao = null
          local.tipo = "FORA_UNIDADE_SAUDE"
          local.sub_tipo = val.tipo
          break

        case 'ignorado':
          local.descricao = null
          local.tipo = "IGNORADO"
          local.sub_tipo = val.tipo
          break

        case 'outros estabelecimentos de saude':
          local.descricao = val.descricao || val.nome
          local.tipo = "UNIDADE_SAUDE"
          local.sub_tipo = val.tipo
          break

        case 'outros':
          local.descricao = null
          local.tipo = 'FORA_UNIDADE_SAUDE'
          local.sub_tipo = val.tipo
          break
        }

        this.editLocalOcorrencia = null

        setTimeout(() => {
          this.editLocalOcorrencia = {
            ...local,
            update: true
          }

          this.registro.local = local

          this.changed()
        })
      },
      addLocalOcorrencia () {
        this.editLocalOcorrencia = {}
      },
      async checkDnv () {
        //Pega o ano do nascimento para validar o DNV
        const birthYear = moment(this.registro.pessoa.data_nascimento).format("YYYY")
        const DNV = this.dnv ? this.dnv.replace(/[-]/ig, '') : ''

        if (DNV.length == 0) {
          this.dnv = null
          return
        }

        //43700000 é a numeração maxima da promeira versão do DNV
        if (DNV.length === 8 && DNV > 43700000) return displayMessage('error', 'Erro!', `D.N.V Número ${DNV} não é válida, numeração superior ao limite da versão`)

        if (birthYear != 2006) { // caso o ano seja 2006 aceitara ambas as versões de DNV
          if (DNV.length === 8 && birthYear >= 2007) { // Não aceita DNV com 8 digitos depois de 2007
            this.dnv = null
            return displayMessage('error', 'Erro!', `D.N.V Número ${DNV} não é válida para o ano informado`)
          }
          if (DNV.length === 11 && birthYear <= 2005) { // Não aceita DNV com 11 digitos antes de 2005
            this.dnv = null
            return displayMessage('error', 'Erro!', `D.N.V Número ${DNV} não é válida para o ano informado`)
          }
        }

        try {
          loader({ text: 'Validando DNV', active: true })
          const valid = await ValidateDeclarationService.validateDnv(DNV, this.registro.registro_id, birthYear)

          if (valid) {
            this.dnv = DNV
            this.$emit('changeDnv', this.dnv)
          }
        } catch (e) {
          this.dnv = null
          return displayMessage('error', 'Erro!', `D.N.V Número ${DNV} não é válida`)
        } finally {
          loader({ text: '', active: false })
        }
      },
      updateFlag (value) {
        this.registro.pessoa.possui_gemeos_crc = value

        this.changed()
      },
      nomeUpperCase () {
        if (this.registro.pessoa.nome) this.registro.pessoa.nome = this.registro.pessoa.nome.toUpperCase()
      },
      dataLimite () {
        return moment(this.limitdate).format("YYYY-MM-DD")
      },
      dataInicial () {
        return moment('1500/01/01').format("YYYY-MM-DD")
      }
    }
  }
</script>

<style lang="scss">

  .btn-add-local:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }

</style>
